























































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { IAnnouncement } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';
import { LinkIcon, PlusIcon } from 'vue-feather-icons';
import CreateAnnouncementModal from '@/views/pages/admin/components/CreateAnnouncementModal.vue';
import AnnouncementsTable from '@/views/pages/admin/AnnouncementsTable.vue';

import { AnnouncementApi } from '@/services/AnnouncementApi';
import AnnouncementModal from '@/modals/AnnouncementModal.vue';

@Component({
  name: 'agencies',
  components: {
    CreateAnnouncementModal,
    LinkIcon,
    PlusIcon,
    AnnouncementsTable,
    AnnouncementModal,
  },
})
export default class Announcements extends mixins(FormatMixin, BaseMixin) {
  announcements: IAnnouncement[] = [];

  selectedAnnouncement: Partial<IAnnouncement> = {};

  async mounted() {
    await this.loadAnnouncements();
  }

  async loadAnnouncements() {
    const response = await AnnouncementApi.getAnnouncements();
    this.announcements = response.data;
  }

  async reload() {
    await this.loadAnnouncements();
  }

  openEditModal(announcement: IAnnouncement) {
    this.selectedAnnouncement = announcement;
    // eslint-disable-next-line
    (this.$refs['edit-announcement-modal'] as any).$refs['edit-announcement'].show();
  }

  openAnnouncement(announcement: IAnnouncement) {
    this.selectedAnnouncement = announcement;
    // eslint-disable-next-line
    (this.$refs['view-announcement-modal-announcements'] as any).$refs['view-announcement'].show();
  }

  async deleteAnnouncement(announcement: IAnnouncement) {
    try {
      if (
        confirm(
          'Wenn das Announcement gelöscht wird, werden alle Benachrichtigungen gelöscht, die dieses Announcement enthalten.',
        )
      ) {
        await AnnouncementApi.delete(announcement.id);
        this.announcements = this.announcements.filter((a) => a.id !== announcement.id);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
